/**
 * Variant selector 2026 — card UI synced with #variant-radios
 */
(function () {
  const ROOT = '[data-pack-selector]';

  function normalizeName(text) {
    return (text || '').replace(/:\s*$/, '').trim().toLowerCase();
  }

  function findFieldset(optionName) {
    const variantSelects = document.getElementById('variant-radios');
    if (!variantSelects) return null;

    const target = normalizeName(optionName);
    const fieldsets = variantSelects.querySelectorAll('fieldset');

    for (let i = 0; i < fieldsets.length; i++) {
      const label = fieldsets[i].querySelector('.swatch-attribute-label');
      if (label && normalizeName(label.textContent) === target) {
        return fieldsets[i];
      }
    }

    return null;
  }

  function hideThemeVariants(packRoot) {
    const variantSelects = document.getElementById('variant-radios');
    if (!variantSelects) return;

    if (packRoot.getAttribute('data-integrate-all') === 'true') {
      variantSelects.classList.add('variant-selector-2026__theme-hidden');
      return;
    }

    if (packRoot.classList.contains('pack-selector--with-theme')) {
      variantSelects.classList.add('variant-selector-2026__theme-companion');
    }

    if (packRoot.getAttribute('data-hide-theme-option') === 'false') return;

    packRoot.querySelectorAll('[data-pack-option-group]').forEach(function (group) {
      const name = group.getAttribute('data-option-name');
      const fieldset = findFieldset(name);
      if (fieldset) fieldset.classList.add('pack-selector__theme-hidden');
    });
  }

  function getProductVariants() {
    const variantSelects = document.getElementById('variant-radios');
    if (!variantSelects) return [];

    const jsonEl = variantSelects.querySelector('script[type="application/json"]');
    if (!jsonEl) return [];

    try {
      return JSON.parse(jsonEl.textContent);
    } catch (error) {
      return [];
    }
  }

  function getSelectedVariantId() {
    const input = document.querySelector(
      '.bls__product-addtocart-form-js input[name="id"], .product-form input[name="id"]'
    );
    return input ? String(input.value) : null;
  }

  function updatePricePctBadge() {
    const variants = getProductVariants();
    const variantId = getSelectedVariantId();
    if (!variantId || !variants.length) return;

    const variant = variants.find(function (item) {
      return String(item.id) === variantId;
    });
    if (!variant) return;

    const priceRoot = document.querySelector('.bls__product-details-infor .bls__price');
    if (!priceRoot) return;

    const compareAt = variant.compare_at_price;
    const price = variant.price;
    let pctEl = priceRoot.querySelector('.bls__price-pct-off');
    const priceRow = priceRoot.querySelector('.bls__product-price');

    if (compareAt && compareAt > price) {
      const pct = Math.round(((compareAt - price) / compareAt) * 100);
      if (!pctEl && priceRow) {
        pctEl = document.createElement('span');
        pctEl.className = 'bls__price-pct-off';
        priceRow.appendChild(pctEl);
      }
      if (pctEl) {
        pctEl.textContent = '-' + pct + '%';
      }
    } else if (pctEl) {
      pctEl.remove();
    }
  }

  function syncGroupCards(group) {
    const optionName = group.getAttribute('data-option-name');
    const fieldset = findFieldset(optionName);
    if (!fieldset) return;

    const active = fieldset.querySelector('.bls__option-swatch.active');
    const value = active ? active.getAttribute('data-value') : null;

    group.querySelectorAll('[data-pack-card]').forEach(function (card) {
      const isActive = card.getAttribute('data-value') === value;
      card.classList.toggle('is-active', isActive);
      card.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    const selectedEl = group.querySelector('[data-pack-selected-value]');
    const themeSelected = fieldset.querySelector('.swatch-selected-value');
    if (selectedEl && value) {
      selectedEl.textContent = value;
    } else if (selectedEl && themeSelected) {
      selectedEl.textContent = themeSelected.textContent.trim();
    }

    group.querySelectorAll('[data-pack-card]').forEach(function (card) {
      const val = card.getAttribute('data-value');
      const match = fieldset.querySelector(
        '.bls__option-swatch[data-value="' + CSS.escape(val) + '"]'
      );
      if (match) {
        const disabled = match.hasAttribute('data-disabled');
        card.disabled = disabled;
        card.classList.toggle('is-unavailable', disabled);
      }
    });
  }

  function selectValue(optionName, value) {
    const fieldset = findFieldset(optionName);
    if (!fieldset) return;

    const swatches = fieldset.querySelectorAll('.bls__option-swatch');
    for (let i = 0; i < swatches.length; i++) {
      if (swatches[i].getAttribute('data-value') === value) {
        swatches[i].click();
        break;
      }
    }
  }

  function initPackRoot(packRoot) {
    if (!packRoot || packRoot.getAttribute('data-pack-init') === 'true') return;
    packRoot.setAttribute('data-pack-init', 'true');

    hideThemeVariants(packRoot);

    const groups = packRoot.querySelectorAll('[data-pack-option-group]');
    groups.forEach(function (group) {
      syncGroupCards(group);

      group.querySelectorAll('[data-pack-card]').forEach(function (card) {
        card.addEventListener('click', function () {
          if (card.disabled) return;
          const optionName = group.getAttribute('data-option-name');
          selectValue(optionName, card.getAttribute('data-value'));
          groups.forEach(syncGroupCards);
          window.setTimeout(updatePricePctBadge, 50);
        });
      });

      const fieldset = findFieldset(group.getAttribute('data-option-name'));
      if (fieldset) {
        fieldset.addEventListener('click', function () {
          window.setTimeout(function () {
            groups.forEach(syncGroupCards);
          }, 0);
        });
      }
    });

    const variantSelects = document.getElementById('variant-radios');
    if (variantSelects) {
      variantSelects.addEventListener('change', function () {
        window.setTimeout(function () {
          groups.forEach(syncGroupCards);
          updatePricePctBadge();
        }, 0);
      });
    }

    updatePricePctBadge();
  }

  function initAll(root) {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(ROOT).forEach(initPackRoot);
  }

  function boot() {
    initAll(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener('load', boot);

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
